// In production we use window.config, set in public/index.html.
// If you change the config properties here,
// you should also change ../server.ts.
export const config =
  process.env.NODE_ENV === 'production'
    ? window.config
    : {
        // WARNING: If you add something here, you must add it to ../public/index.html and ../server.ts as well!
        baseUrl: process.env.REACT_APP_BASE_URL || 'http://localhost:3001',
        keycloakClientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'spex',
        keycloakRealm: process.env.REACT_APP_KEYCLOAK_REALM || 'spex',
        keycloakUrl: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080',
        hashidSecret: process.env.REACT_APP_HASHID_SECRET || 'abc',
        tokenRefreshInterval: process.env.REACT_APP_TOKEN_REFRESH_INTERVAL || 60 * 1000, // 1 minute
        dashboardsEnabled: process.env.REACT_APP_DASHBOARDS_ENABLED === 'true',
      }
